import React from 'react';
import styled from 'styled-components';
import Store from '../../Common/Store';
import { IoIosArrowUp} from "react-icons/io";
import CSLTable from '../Common/CSLTable';

const SelectedRadio = styled.div`
	background-color: #37ADA7;
	border: 1px solid #1f615e;
	padding: 5px 10px;
	color: #ffffff;
	display: inline-block;
	cursor: pointer;
`;
const UnselectedRadio = styled.div`
	background-color: #F4F4F4;
	border: 1px solid #8c8c8c;
	padding: 5px 10px;
	color: #262626;
	display: inline-block;
	cursor: pointer;
`;
const GeneralContainer = styled.div`
	width: 90%;
`;
const GeneralInnerContainer = styled.div`
	background-color: #ffffff;
	padding: 30px;
`;
const GeneralLabel = styled.div`
	font-weight: 600;
	color: #595959;
	margin-top: 20px;
`;
const RadioBlock = styled.div`
	margin-top: 10px;
`;
const RegModalNameLabelDiv = styled.div`
    color: #252525;
    font-weight: 600;
	margin-top: 10px;
	margin-bottom: 10px;
`;
const MRModalSelect = styled.select`
    display: block;
    box-sizing: border-box;
    height: 35px;    
    background-color: #fff;
    border: 1px solid #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 4px #c4c4c4;
    font-family: Montserrat,sans-serif;
    color: #484848;
`;

const OverviewInfoHeader = styled.div`
    padding: 12px 15px;
    background-color: #04ada8;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;    
    width: 96%;
    margin: 0 auto; 
    height: 20px;       
`;
const OverviewInfoBody = styled.div`
	padding: 15px;
    background-color: #ffffff;
    border: 1px solid #d7dddf;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 96%;
    margin: 0 auto;
    margin-bottom: 30px;
`;
const SaveBtn = styled.button`
	padding: 10px 30px;
	background-color: #37ADA7;
	border: 1px solid #37ADA7;
	border-radius: 2px;
	color: #ffffff;
	cursor: pointer;
	margin-left: 15px;
`; 

class AutoDismissGeneral extends React.Component
{
	state = { ready: false, regulatorListAll: [], rowchecked: false, autoDismissRegulatorName: {}};

	componentDidMount()
	{
        let allselectcheckContact = true;
        let autoDismissRegulatorName = this.props.general.autoDismissRegulatorName;
        let regulatorListAll = Store.getStoreData('ragulatorsname'); 
        let removeregulatorobject = {'FCA': 1,'PRA': 1,'HMT':1,'ICO': 1, 'PSR': 1, 'EBA': 1, 'EIOPA': 1, 'ESMA': 1, 'UK Authorities': 1, 'ESAs': 1, 'SEC': 1}   
        let updated_regulatorListAll = []; 
        let update_autoDismissRegulatorName = {};   
        regulatorListAll.forEach((value) => {  
            if(value.knownAs in removeregulatorobject){
                if(this.props.general.isAutoDismissRegulatorNameCheck !== 0){
                    value.select = false;
                    if(value.ragulatorname in autoDismissRegulatorName){                        
                        value.select = true;
                        autoDismissRegulatorName[value.ragulatorname] = value.knownAs;
                        if(autoDismissRegulatorName[value.ragulatorname] in removeregulatorobject) {
                            update_autoDismissRegulatorName[value.ragulatorname] = value.knownAs;
                        }
                    }
                }else{
                    value.select = true;
                    autoDismissRegulatorName[value.ragulatorname] = value.knownAs;
                    update_autoDismissRegulatorName[value.ragulatorname] = value.knownAs;
                }
                updated_regulatorListAll.push(value);
            }
        })        
        updated_regulatorListAll.forEach((user) => {            
            if(!user.select){
                allselectcheckContact = false
            }
        })
        console.log("autoDismissRegulatorName",autoDismissRegulatorName)
        console.log("update_autoDismissRegulatorName",update_autoDismissRegulatorName)
        this.setState({regulatorListAll: updated_regulatorListAll, rowchecked: allselectcheckContact, autoDismissRegulatorName: update_autoDismissRegulatorName, ready: true})
    }

    selectRegulatorsAll = (event) => {
        let rowchecked = this.state.rowchecked;
        rowchecked = rowchecked ? false : true;        
        let regulatorListAll = this.state.regulatorListAll;         
        
       if(rowchecked) {   
            let i = 0;            
            let selectArray = [];
            for(let d of regulatorListAll) {                
                let selectObject = {}           
                i++;   
                // let val = 1;            
                this.state.autoDismissRegulatorName[d.ragulatorname] = d.knownAs;                          
                selectObject.id = d.id;
                selectObject.knownAs = d.knownAs;
                selectObject.ragulatorname = d.ragulatorname;                              
                selectObject.select = true;                                
                selectArray.push(selectObject)
            }
            this.setState({rowchecked: rowchecked,regulatorListAll: selectArray, autoDismissRegulatorName: this.state.autoDismissRegulatorName})
       }else{
            let i = 0;            
            let selectArray = [];
            for(let d of regulatorListAll) {                
                let selectObject = {}           
                i++; 
                delete this.state.autoDismissRegulatorName[d.ragulatorname.toString()];                            
                selectObject.id = d.id;
                selectObject.knownAs = d.knownAs;
                selectObject.ragulatorname = d.ragulatorname;                    
                selectObject.select = false;                                
                selectArray.push(selectObject)
            }
            this.setState({rowchecked: rowchecked,regulatorListAll: selectArray, autoDismissRegulatorName: this.state.autoDismissRegulatorName})
       }
   }

   selectRegulator = (event) => {        
        let index = event.target.value;        
        var regulatorListAll = this.state.regulatorListAll;        
            
        if(regulatorListAll[index].select){
            regulatorListAll[index].select = false;            
            delete this.state.autoDismissRegulatorName[regulatorListAll[index].ragulatorname.toString()];                    
        } else {
            regulatorListAll[index].select = true;            
            let userid = regulatorListAll[index].ragulatorname.toString();                 
            this.state.autoDismissRegulatorName[userid] = regulatorListAll[index].knownAs;                            
        }
        this.setState({regulatorListAll: regulatorListAll, rowchecked: false, autoDismissRegulatorName: this.state.autoDismissRegulatorName})
        let allselectcheck = true
        for(let d of regulatorListAll) {
            // console.log("select",d.select);
            if(!d.select){
                allselectcheck = false
            }
        }
        if(allselectcheck){
            this.setState({rowchecked: true})
        }
    }

    processRegulatorListData = () => {            
        var regulatorList = this.state.regulatorListAll; 
        console.log("regulatorList==>", regulatorList)     
        let ret = {data: [], columns: []};
        let i = 0;
        ret.columns =[{'Header' : <div><input type="checkbox" checked={this.state.rowchecked} onClick={this.selectRegulatorsAll}/></div>, sortable: false, Cell: row => (
                        <div>
                            <input type="checkbox" checked={row.original.select} value={row.index} onClick={this.selectRegulator}/>
                        </div>
                    ), width: 142, headerStyle: {textAlign: 'left'}},         
                    {Header: 'Regulators', accessor: 'name_value', Cell: row => (
                        <div title={row.original.regulator_name}>{row.original.name_value}</div>
                    ),minWidth: 100, headerStyle: {textAlign: 'center'}}];         
        regulatorList.sort(function(a,b) {return (a.knownAs > b.knownAs) ? 1 : ((b.knownAs > a.knownAs) ? -1 : 0);} );              
        for(let d of regulatorList) {     
            //console.log("regulatorList==>", d)      
            i++;
            let elem = {'index' : i,
                    'id': d.id, 
                    'regulator_name' : d.ragulatorname,
                    'name_value' : d.knownAs,
                    'select' : d.select                    
                    };
            ret.data.push(elem);        
        }        
        return ret;
    }

    submitAutoDismissData = (event) => {
        event.preventDefault();
        console.log("autoDismissRegulatorName==>",this.state.autoDismissRegulatorName) 
        this.props.saveAutoDismissValue(this.state.autoDismissRegulatorName);
    }

    

	render()
	{  
        if(!this.state.ready){
            return(<div></div>)
        }      
		return (
            <div>
                <div style={{marginTop: "20px"}}>
                <OverviewInfoHeader>
                    <div style={{float: "left", color: "#ffffff", fontWeight: "600"}}>Regulators</div> 
                    <div style={{float: "right", color: "#ffffff", fontSize: "17px"}}><IoIosArrowUp /></div>
                    <div style={{clear: "both"}}></div>
                </OverviewInfoHeader>
                <OverviewInfoBody>
                    <CSLTable add={false} processData={this.processRegulatorListData} headerText={''} tableRows={5}/>                   
                </OverviewInfoBody> 
                </div>                               
                <div style={{float: "right",marginTop: "-20px"}}>                        
                    <SaveBtn onClick={this.submitAutoDismissData}>Save Auto Dismiss Data</SaveBtn>
                </div>
                
            </div>			
		);
	}
}

export default AutoDismissGeneral;